import type { HelpFile } from '../../types/help'
import { JobExecutionsTestIds } from '../../../testids/JobExecutionsTestIds'

export const jobExecutionsHelp: HelpFile = {
  docPage: '/docs/jobs/job-scheduler',
  texts: {
    [JobExecutionsTestIds.jobExecutionsPage]:
      'Every recent execution of every scheduled or manually triggered job — use this view to confirm a job ran, see how long it took, and inspect failures.',
    [JobExecutionsTestIds.btnClearJobFilter]: null,
    [JobExecutionsTestIds.colJobName]:
      'Which job ran — click to open the job detail page with its definition and full history.',
    [JobExecutionsTestIds.colNode]:
      'Cluster node that picked up and ran this execution — useful when diagnosing a node-specific issue.',
    [JobExecutionsTestIds.colStarted]:
      'When the execution kicked off — combine with duration to spot drift in scheduled run times.',
    [JobExecutionsTestIds.colTasks]:
      'Number of individual tasks the execution processed — for fan-out jobs, this is the per-run unit-of-work count.',
  },
}
